import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FavouritesStateService {
  private readonly KEY = 'hasFavourites';

  getFlag(): boolean | null {
    const val = localStorage.getItem(this.KEY);
    return val === null ? null : val === 'true';
  }

  setFlag(value: boolean): void {
    localStorage.setItem(this.KEY, String(value));
  }
}
